import { useEffect } from "react";

/** Per-route document title + description for SEO and screen readers. */
export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
      const og = document.querySelector('meta[property="og:title"]');
      if (og) og.setAttribute("content", title);
      const ogd = document.querySelector('meta[property="og:description"]');
      if (ogd) ogd.setAttribute("content", description);
    }
  }, [title, description]);
}
